import React from "react";

const ResultCard = (props) => {
  return (
    <div className="flex justify-center p-4 cursor-pointer">
      <div className="block shadow-lg max-w-sm text-center">
        <div className="flex justify-center">
          <div className="shadow-lg max-w-sm ">
            <div
              className="md:flex hidden w-56 h-56"
              data-mdb-ripple="true"
              data-mdb-ripple-color="light"
            >
              <img
                className="object-fit rounded-md"
                src={props.imgLink}
                alt=""
              />
            </div>
            <a
              className="md:hidden flex w-56 h-56 cursor-pointer"
              href={props.url ? props.url : "#"}
              data-mdb-ripple="true"
              data-mdb-ripple-color="light"
            >
              <img
                className="object-fit rounded-md"
                src={props.imgLink}
                alt=""
              />
            </a>
            <div className="p-3">
              <h5 className="text-white text-xl font-semibold truncate w-56 -ml-3 mt-2">
                {props.title}
              </h5>
              <p className="text-white text-base truncate w-56 -ml-3">
                {props.artist}
              </p>
            </div>
            {props.buttonVisible && (
              <button
                type="button"
                className=" inline-block px-6 py-2 bg-blue-600 text-white font-semibold text-md leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              >
                {props.percentage} %
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultCard;
